import { createRouter, createWebHistory } from "vue-router";
import { routes } from "./routes";

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,

    //https://github.com/vuejs/router/issues/1411#issuecomment-1132582259
    //Workaround. When you are using router-link after click re-render component, but not scroll up
    async scrollBehavior(to, from, savedPosition) {
        return { top: 0, behavior: 'smooth' };
    }
});

//Meta logic
import { TITLE_TAGS, DESCRIPTION_TAGS } from '@/constants/meta-tags';
import Cookies from "js-cookie";

router.afterEach((to, from) => {
    let langCookie = Cookies.get('.Nop.Culture') || 'en';
    let match = langCookie.match(/c=([a-zA-Z]{2})/);
    let lang = match ? match[1] : 'en';

    let metaDescription = document.querySelector('meta[name="description"]'),
        titleTag = TITLE_TAGS[window.location.pathname] || TITLE_TAGS['/'];

    document.title = titleTag.title[lang] + ' | Trimm, Inc.';

    if (metaDescription)
        metaDescription.setAttribute("content", DESCRIPTION_TAGS[titleTag.descriptionId][lang]);
});

export default router;
